import React from "react";

function Note({ title = "Note", content, className = "" }) {
  return (
    <div className={`note ${className}`}>
      <h3>{title}</h3>
      <div className="note-content">{content}</div>
    </div>
  );
}

export default Note;
